angular.module('protocol_step', ['ui.router','confirm.modal.html', 'ngResource', 'ngTable', 'ui.bootstrap']);

angular.module('protocol_step').config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {

    $stateProvider
    .state('protocol_step', {
        url         : "/protocol_step",
        templateUrl : server+"/views/m/protocol_step",
        controller  : 'protocol_step.list',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'home',
            label: 'ProtocolStep'
        }
    })

    .state('protocol_step_create', {
        url         : "/protocol_step/create",
        templateUrl : server+"/views/m/protocol_step/create",
        controller  : 'protocol_step.create',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'protocol_step',
            label: 'Adicionar'
        }
    })

    .state('protocol_step_show', {
        url         : "/protocol_step/:id",
        templateUrl : server+"/views/m/protocol_step/show",
        controller  : 'protocol_step.show',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'protocol_step',
            label: '{{protocol_step.id}}'
        }
    })

}]);

/**
 * List Controller
 */
angular.module('protocol_step').
controller('protocol_step.list', ['$scope', '$http', '$auth', '$q', 'NgTableParams', '$protocol_step', function($scope, $http, $auth, $q, NgTableParams, $protocol_step) {
    $scope.tableParams = new NgTableParams({
        page: 1,
        count: 10
    }, {
        counts: [],
        filterDelay: 0,
        getData: function(params) {
            return $protocol_step.query(params.url()).$promise.then(function(data) {
                params.total(data.total);
                return data.data;
            });
        }
    });
}]);

/**
 * Create Controller
 */
angular.module('protocol_step').
controller('protocol_step.create', ['$scope', '$state', '$protocol_step', function($scope, $state, $protocol_step) {
    $scope.save = function() {
        $protocol_step.save($scope.protocol_step).$promise.then(function(data) {
            $state.go('protocol_step_show', {
                id: data.id
            });
        });
    }
}]);

/**
 * Show, Edit, Delete Controller
 */
angular.module('protocol_step').
controller('protocol_step.show', ['$state', '$scope', '$stateParams', '$uibModal', '$protocol_step', function($state, $scope, $stateParams, $uibModal, $protocol_step) {

    $scope.editing = false;

    $scope.toggleEdit = function() {
        $scope.editing = !$scope.editing;
    }

    $protocol_step.get({
        id: $stateParams.id
    }).$promise.then(function(data) {
        $scope.protocol_step = data;
    }, function(error) {
        if (error.status == 404) {
            $state.go('notFound');
        }
    });

    $scope.confirmUpdate = function() {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'confirm.modal.html',
            size: 'sm',
            scope: $scope,
            controller: ['$scope', '$uibModalInstance', '$protocol_step', function($scope, $uibModalInstance, $protocol_step) {

                $scope.title = 'Deseja atualizar?';
                $scope.cancel_text = 'Cancelar';
                $scope.success_text = 'Concluído';

                var protocol_step = $scope.$parent.protocol_step;

                $scope.confirm = function() {
                    $protocol_step.update({
                        id: protocol_step.id
                    }, protocol_step).$promise.then(function(data) {
                        $uibModalInstance.dismiss('cancel');
                        $scope.$parent.toggleEdit();
                    })
                }

                $scope.cancel = function() {
                    $uibModalInstance.dismiss('cancel');
                };

            }]
        });
    };

    $scope.confirmDelete = function() {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'confirm.modal.html',
            size: 'sm',
            scope: $scope,
            controller: ['$state', '$scope', '$uibModalInstance', '$protocol_step', function($state, $scope, $uibModalInstance, $protocol_step) {

                $scope.title = 'Deseja remover esse registro?';
                $scope.cancel_text = 'Não';
                $scope.success_text = 'Sim';

                var protocol_step = $scope.$parent.protocol_step;

                $scope.confirm = function() {
                    $protocol_step.delete({id:protocol_step.id}).$promise.then(function(data){
                        $uibModalInstance.dismiss('cancel');
                        $state.go('protocol_step');
                    })
                }

                $scope.cancel = function() {
                    $uibModalInstance.dismiss('cancel');
                };

            }]
        });
    };

}]);


/**
 * Factory
 */
angular.module('protocol_step').
factory("$protocol_step", function($resource) {
    var resource = $resource(api + 'protocol_step/:id', null, {
        'query': {
            method: 'GET',
            isArray: false
        },
        'update': {
            method: 'PUT'
        }
    });
    return resource;
});

angular.module("confirm.modal.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put('confirm.modal.html',
        '<div class="modal-body">' +
        ' {{title}}' +
        '</div>' +
        '<div class="modal-footer">' +
        '    <button class="btn btn-link btn-info" type="button" ng-click="cancel()">{{cancel_text}}</button>' +
        '    <button class="btn btn-outline btn-success" type="button" ng-click="confirm()">{{success_text}}</button>' +
        '</div>'
    );
}]);
